export default __webpack_public_path__ + "static/excel-bee-abd503fa443fe84922559bc2fb02a178.png";